import type { Offer, Product, RecurrencePlan } from '../api/product.contract'

export const MAX_OFFERS_PER_PRODUCT = 1
export const MAX_PLANS_PER_PRODUCT = 1

export function primaryOfferIdOf(product: Pick<Product, 'offers' | 'links'>): string {
  const declared = product.links?.primaryOfferId || product.links?.offers[0]?.offerId || ''
  if (declared && product.offers.some((offer) => offer.id === declared)) {
    return declared
  }
  return product.offers[0]?.id || declared
}

export function orderOffersByPrimary(product: Pick<Product, 'offers' | 'links'>): Offer[] {
  const primaryOfferId = primaryOfferIdOf(product)
  return [...product.offers].sort((left, right) => {
    if (left.id === primaryOfferId) return -1
    if (right.id === primaryOfferId) return 1
    return 0
  })
}

export function editableOffers(product: Pick<Product, 'offers' | 'links'>): Offer[] {
  return orderOffersByPrimary(product).slice(0, MAX_OFFERS_PER_PRODUCT)
}

export function sellableOffers(product: Pick<Product, 'offers' | 'links'>): Offer[] {
  return orderOffersByPrimary(product)
    .filter((offer) => offer.status === 'ACTIVE')
    .slice(0, MAX_OFFERS_PER_PRODUCT)
}

export function editablePlans(product: Pick<Product, 'recurrencePlans'>): RecurrencePlan[] {
  return (product.recurrencePlans ?? []).slice(0, MAX_PLANS_PER_PRODUCT)
}

export function sellablePlans(product: Pick<Product, 'recurrencePlans'>): RecurrencePlan[] {
  return (product.recurrencePlans ?? [])
    .filter((plan) => plan.active)
    .slice(0, MAX_PLANS_PER_PRODUCT)
}

export function canAddOffer(product: Pick<Product, 'offers'>): boolean {
  return product.offers.length < MAX_OFFERS_PER_PRODUCT
}

export function canAddPlan(product: Pick<Product, 'recurrencePlans'>): boolean {
  return (product.recurrencePlans ?? []).length < MAX_PLANS_PER_PRODUCT
}
